export default __webpack_public_path__ + "static/media/icon-profile-3.51bef514.svg";